import { BidDecisionGroup, Customer, RevenueCalculationType } from "@/graphql/__generated__/graphql";
import { toast } from "react-toastify";
import { CustomToastComponent } from "@/components/shared";

/**
 * Prefills the Permanent Service form with mock data for testing.
 *
 * @param form - react-hook-form instance controlling the Permanent Service form
 * @param customer - current customer to derive sites from
 * @param biddingOperationalOrganizations - available operational org groups for selection
 * @param currentOrgId - current user's organization id
 */
export function prefillPermanentServiceWithMockData(
  form: any,
  customer: Customer,
  biddingOperationalOrganizations: Partial<BidDecisionGroup>[],
  currentOrgId?: number
) {
  const { setValue, trigger } = form;

  // Determine operational organization: prefer matching current org, else first available
  let selectedOperationalOrgId: number = 0;
  const matchingOperationalOrg = biddingOperationalOrganizations.find(
    (org) => (org.operationalOrganizationId ? Number(org.operationalOrganizationId) : undefined) === currentOrgId
  );

  if (matchingOperationalOrg?.operationalOrganizationId) {
    selectedOperationalOrgId = Number(matchingOperationalOrg.operationalOrganizationId);
  } else {
    const firstOrg = biddingOperationalOrganizations[0];
    selectedOperationalOrgId = firstOrg?.operationalOrganizationId ? Number(firstOrg.operationalOrganizationId) : 0;
  }

  // Get the first site from customer
  const firstSite = customer?.sites?.[0];
  const siteId = firstSite?.id;

  // Create mock shift data that passes validation
  const mockShift = {
    employeeQuantity: 2,
    subContractorQuantity: 0,
    startTime: "08:00",
    endTime: "17:00",
    holiday: false,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: false,
    sunday: false,
    applyHolidayPay: false,
    startDate: undefined,
    endDate: undefined,
    pauseStartTime: "12:00",
    pauseEndTime: "13:00",
  };

  // Create mock service data that passes validation
  const mockServiceData = {
    additional: false,
    name: "Mock Security Service",
    operationalOrganizationId: selectedOperationalOrgId,
    hourlyWage: 25.5,
    hoursBriefingPerEmployee: 8,
    transferredEmployeePercentage: 15,
    siteId: siteId,
    payGroup: "x",
    nonTariffAllowance: 2.5,
    info: "Mock service for testing purposes",
    shifts: [mockShift],
    pauseIncluded: true,
    siteInput: undefined,
    revenueCalculationType: RevenueCalculationType.Margin,
    margin: 10,
    flatRate: undefined,
    hourlyRateAbsolute: undefined,
    hourlyRateRelative: undefined,
  };

  // Set all form values
  Object.entries(mockServiceData).forEach(([key, value]) => {
    setValue(key as any, value);
  });

  // Trigger validation
  trigger();

  toast(CustomToastComponent, {
    toastId: "mock-data-prefilled",
    data: {
      title: "Mock data prefilled successfully",
      type: "success",
    }
  });
}
